import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { buildUrl, ContentRoute,RouteSlotInput  } from '@caritas/ui';

import { buildMessages, redirectWithUserUpdate } from '../../utils/iframe';

export const mapLoginRegisterBlock = (
  pageContext: SilverbackPageContext,
  redirectPath?: string,
  isBooking?: boolean,
  bookingItems?: string,
  showForm?: string,
) =>
  function (): RouteSlotInput<typeof ContentRoute, 'body', 'formEmbed'> {
    const redirectPathFromCurrentLocation = function() {
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('redirectPath');
      }
      return undefined;
    }

    const formRedirectPath = redirectPath ? redirectPath : redirectPathFromCurrentLocation();
    return {
      key: 'formEmbed',
      input: () => [
        {
          url: buildUrl(
            [
              process.env.GATSBY_DRUPAL_CLIENT_URL || '/',
              pageContext.locale,
              'cms',
              'pages',
              'login_register',
            ],
            {
              redirectPath: formRedirectPath,
              isBooking,
              bookingItems,
              show: showForm
            },
          ),
          buildMessages: buildMessages(),
          redirect: redirectWithUserUpdate,
        },
        200,
      ],
    };
  };
